export const medallionCost = 199;
